import { Mixin } from 'mixwith';
import { ElementNodeBuilder } from 'Editor/services/Model';
import { ELEMENTS } from 'Editor/services/consts';
import { Logger } from '_common/services';

export default Mixin(
  (superclass) =>
    class extends superclass {
       
      parseNote(representation) {
        const builder = new ElementNodeBuilder();
        builder.addElementType('note');

        // parse properties
        const mapper = this.editorContext.visualizerManager
          .getViewFactory()
          ?.getAttributeMapper(ELEMENTS.NoteElement.ELEMENT_TYPE);
        Object.keys(mapper).forEach((prop) => {
          try {
            mapper[prop].parse(representation, builder);
          } catch (e) {
            Logger.captureException(e);
          }
        });

        return builder.getNode();
      }
    },
);
